import HtmlRenderer from './html-renderer';

export default HtmlRenderer;
